<template>
  <div class="container">
    <evollu-arrow
      v-for="item in list"
      :is-active="leadIsActiveState(item)"
      :is-first="item.list_id === 1"
      :is-last="item.list_id === list.length"
      :key="item.list_id"
      :style="{left: (((item.list_id-1)%4)*(-25))+'px'}"
      :title="getItemLabel(item)"
      @click="handleItemClicked(item)"
      component-class="arrow"
    ></evollu-arrow>

    <ConfirmationModal
      v-if="showConfirmationModal"
      :title="getConfirmationModalTitle"
      :body="getConfirmationModalBody"
      @modal-confirmed="handleConfirmMove"
      @modal-canceled="handleConfirmationCanceled"/>
  </div>
</template>

<script>
import ConfirmationModal from '@/components/common/ConfirmationModal'
import { LeadsWebService } from '@/api/LeadsWebService'
import { mapState } from 'vuex'
import EvolluArrow from '@/components/leads-web/dashboard/EvolluArrow'

const NOT_CONFIRMED_LEAD_STATUS = 2
const COLUMN_TYPE_ACTION = 'action'
const COLUMN_TYPE_STATUS = 'status'

export default {
  components: { EvolluArrow, ConfirmationModal },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    lead: {
      type: Object,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      stageToMove: {},
      showConfirmationModal: false,
    }
  },
  methods: {
    getItemLabel (item) {
      if (item.type === COLUMN_TYPE_STATUS) {
        return this.$t(item.name)
      }
      if (item.type === COLUMN_TYPE_ACTION) {
        return item.name
      }
      return 'N/A'
    },
    leadIsActiveState (item) {
      if (this.lead.status.id === NOT_CONFIRMED_LEAD_STATUS && item.type === COLUMN_TYPE_ACTION && item.id === this.lead.lastContactAction.id) {
        return true
      } else if (this.lead.status.id !== NOT_CONFIRMED_LEAD_STATUS && item.type === COLUMN_TYPE_STATUS && item.id === this.lead.status.id) {
        return true
      }
      return false
    },
    handleItemClicked (item) {
      if (this.canEdit) {
        this.stageToMove = item
        this.showConfirmationModal = true
      }
    },
    handleConfirmMove () {
      if (this.lead && this.stageToMove) {
        // If lead is going to an action type column, call the action
        if (this.stageToMove.type === COLUMN_TYPE_ACTION) {
          LeadsWebService.runManualAction(this.lead.id, this.stageToMove.id).then(res => {
            this.showToast(this.$t('leads-web.leads.move-success-action', { action: this.stageToMove.name }), this.$store.state.successToastOptions)
          }).catch(err => {
            this.showToast(this.$t('leads-web.leads.move-error'), this.$store.state.errorToastOptions)
            console.log(err)
          }).finally(() => {
            this.stageToMove = {}
            this.showConfirmationModal = false
            this.$emit('lead-updated')
          })
        } else if (this.stageToMove.type === COLUMN_TYPE_STATUS) {
          let data = { ...this.lead }
          data.status.id = this.stageToMove.id
          LeadsWebService.update(this.lead.id, data).then(res => {
            this.showToast(this.$t('leads-web.leads.move-success-status', { status: this.$t(this.stageToMove.name) }), this.$store.state.successToastOptions)
          }).catch(err => {
            console.log(err)
            this.showToast(this.$t('leads-web.leads.move-error'), this.$store.state.errorToastOptions)
          }).finally(() => {
            this.stageToMove = {}
            this.showConfirmationModal = false
            this.$emit('lead-updated')
          })
        }
      }
    },
    handleConfirmationCanceled () {
      this.stageToMove = {}
      this.showConfirmationModal = false
      // this.$emit('lead-updated')
    }
  },
  computed: {
    ...mapState({
      'leadsWebToken': (state) => state.leadsWeb.leadsWebSrvToken
    }),
    getConfirmationModalTitle () {
      return this.stageToMove.type === COLUMN_TYPE_ACTION
        ? this.$t('leads-web.leads.confirm-move-action-title')
        : this.$t('leads-web.leads.confirm-move-status-title')
    },
    getConfirmationModalBody () {
      return this.stageToMove.type === COLUMN_TYPE_ACTION
        ? this.$t('leads-web.leads.confirm-move-action', { name: this.lead.name, action: this.stageToMove.name })
        : this.$t('leads-web.leads.confirm-move-status', {
          name: this.lead.name,
          status: this.$t(this.stageToMove.name)
        })
    },
  }
}
</script>

<style lang="scss">

.arrow {
  fill: white;
  cursor: pointer;
}

.arrow:hover {
  fill: rgba(41, 196, 170, 0.4);
}

.arrow.active {
  fill: #29C4AA;
  color: white;
}

</style>
